import React from 'react';
import { Link } from 'react-router-dom';
import { Home as HomeIcon, ArrowLeft } from 'lucide-react';
import Seo from '../components/Seo';
import { contactInfo } from '../mock';

export default function NotFound() {
  return (
    <div className="min-h-screen bg-[#0a0a0a] flex flex-col">
      <Seo
        title="Page Not Found (404) | Simply Gold Productions"
        description="The page you're looking for doesn't exist. Explore Simply Gold Productions' video work or head back to the homepage."
        path="/404"
        noindex
      />
      <header className="border-b border-white/10">
        <div className="max-w-7xl mx-auto px-6 py-4">
          <Link to="/" aria-label="Simply Gold Productions home" className="inline-flex">
            <img src="/sgp-logo-header.png" alt="Simply Gold Productions logo" width="1222" height="629" className="h-12 md:h-14 w-auto object-contain" />
          </Link>
        </div>
      </header>

      <main className="flex-1 flex items-center justify-center px-6 text-center">
        <div>
          <p className="font-display tracking-[0.4em] text-[#c9a85f] text-sm uppercase mb-6">Error 404</p>
          <h1 className="font-display font-bold text-white text-5xl md:text-7xl uppercase leading-[0.95]">
            Page Not Found
          </h1>
          <p className="mt-6 text-white/60 max-w-lg mx-auto">
            We couldn't find that page. It may have been moved or no longer exists.
          </p>
          <div className="mt-10 flex flex-col sm:flex-row items-center justify-center gap-4">
            <Link to="/" data-testid="notfound-home-link" className="inline-flex items-center gap-2 bg-[#c9a85f] hover:bg-[#d8b970] text-black font-display font-semibold px-7 py-3.5 rounded-md transition-colors tracking-wide">
              <HomeIcon size={18} /> Back to Homepage
            </Link>
            <Link to="/documentaries" className="inline-flex items-center gap-2 text-white/85 hover:text-[#c9a85f] font-display font-medium px-4 py-3.5 tracking-wide transition-colors">
              <ArrowLeft size={18} /> Browse Our Documentaries
            </Link>
          </div>
        </div>
      </main>

      <footer className="py-8 text-center text-white/40 text-xs border-t border-white/10">
        © {new Date().getFullYear()} {contactInfo.company} — {contactInfo.tagline}
      </footer>
    </div>
  );
}
